/*
 * Enables the "Icon stroke width" Theme Editor control on the
 * "GLOON - How It Works" bottom bar icons.
 *
 * CSS cannot reach inside an <img src="icon.svg">: the SVG is loaded as an
 * opaque external resource, so its internal <path> stroke-width is not
 * reachable from the page stylesheet. This only swaps the <img> for the
 * fetched inline <svg> so CSS custom properties can then reach it. If the
 * asset isn't an SVG, or the fetch fails, the original <img> is left
 * untouched (no visual change, no error).
 */
document.querySelectorAll('[data-gloon-stroke-icon]').forEach(function (wrapper) {
  var img = wrapper.querySelector('img');
  if (!img) return;

  var src = img.getAttribute('src') || '';
  if (!/\.svg(\?|$)/i.test(src)) return;

  fetch(src)
    .then(function (response) {
      return response.ok ? response.text() : null;
    })
    .then(function (svgText) {
      if (!svgText) return;

      var svg = new DOMParser().parseFromString(svgText, 'image/svg+xml').querySelector('svg');
      if (!svg) return;

      var altText = img.getAttribute('alt');
      if (altText) {
        svg.setAttribute('role', 'img');
        svg.setAttribute('aria-label', altText);
      } else {
        svg.setAttribute('aria-hidden', 'true');
      }

      wrapper.replaceChild(svg, img);
    })
    .catch(function () {
      /* Leave the original <img> in place. */
    });
});
